export const INDUSTRIES = [
  "Accounting",
  "Advertising",
  "Aerospace",
  "Agriculture",
  "Architecture",
  "Automotive",
  "Aviation",
  "Banking",
  "Biomedical Engineering",
  "Biotechnology",
  "Chemical Engineering",
  "Civil Engineering",
  "Computer Engineering",
  "Construction",
  "Consulting",
  "Consumer Goods",
  "Cybersecurity",
  "Data Science",
  "Defense",
  "E-commerce",
  "Education",
  "Electrical Engineering",
  "Energy",
  "Engineering",
  "Entertainment",
  "Environmental Science",
  "Fashion",
  "Finance",
  "Food & Beverage",
  "Gaming",
  "Government",
  "Healthcare",
  "Hospitality",
  "Human Resources",
  "Industrial Engineering",
  "Insurance",
  "Investment Banking",
  "Journalism",
  "Law",
  "Logistics",
  "Manufacturing",
  "Marketing",
  "Mechanical Engineering",
  "Media",
  "Medicine",
  "Music",
  "Non-profit",
  "Nuclear Engineering",
  "Nursing",
  "Pharmaceuticals",
  "Politics & Policy",
  "Private Equity",
  "Product Management",
  "Public Health",
  "Public Relations",
  "Real Estate",
  "Research",
  "Retail",
  "Social Work",
  "Software Engineering",
  "Sports",
  "Startups",
  "Supply Chain",
  "Systems Engineering",
  "Technology",
  "Telecommunications",
  "Transportation",
  "Urban Planning",
  "Venture Capital",
  "Web3 / Crypto",
  "Other",
];
